<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dQHcI5/tc-custom/9781398462847.jpg?1682168954006" alt="This image is the cover for the book Love You, Love Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Love You, Love Me
      </h1>
      <p class="bookDescription body article font2">
        <p>‘Love you, love me,’ she grinned, ‘Jess, remember to have your head in the stars and your feet firmly on the ground.’ ‘And dance in the rain.’ Jess, Crystal and Sophie had been friends since primary school but becoming a teenager brings its own challenges as the girls soon discover. At an age when life offers more opportunities and with it self-doubt and insecurities, Jess and her friends navigate the school social, an out-of-control party, underage drinking and family dynamics whilst trying to make sense of growing up. Throw in Steve, the mysterious charismatic new student that sells drugs that cure headaches, Vincent, the perfect date and Jake, a persistently annoying guy, and life becomes more interesting. Will they individually find the courage to ask for help as they deal with bothersome boys, self-harm, anxiety, confusion and overwhelming conditions? Or will they together discover through friendship, family and first love that no one is perfect?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Claire Chitty
      </h2>
      
      <p class="authorDescription body article">Claire is an Australian author who has been writing picture story and children’s books since the age of 6. This is her first young adult novel. She sees herself as an observer of life and her philosophy is to create stories that entertain, inspire, educate or challenge the reader, whilst tacking subjects that children and adults alike can relate to such as food allergies, disability, organ transplant, mental health, Australian bushfires and floods. She can often be found writing at her desk with a chai latte and a cat on her lap.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07ce4901